import { AxiosInstance } from 'axios'
import { AccessDenied } from 'shared/errors/access-denied'
import { LockedError } from 'shared/errors/locked'
import { ErrorResponseInterface } from 'shared/types/error-response-content-interface'

export enum RequestMethodsEnum {
  get = 'get',
  delete = 'delete',
  head = 'head',
  options = 'options',
  post = 'post',
  put = 'put',
  patch = 'patch',
  postForm = 'postForm',
}

export type UseApiWrapperWithErrorValidationProps<
  R,
  M extends RequestMethodsEnum,
  BadRequestError = ErrorResponseInterface,
> = {
  method: M
  showFieldsErrorToast?: boolean
  badRequestHandler?: null | ((error: BadRequestError) => void)
  unprocessableContentHandler?: (error: unknown) => void
  unauthorizedResponseHandler?: (error: unknown) => void
  afterFetch?: (data: R) => Promise<R> | R
  stopErrorPropagation?: boolean
  notFoundResponseHandler?: (error: unknown) => void
  accessDeniedResponseHandler?: (error: AccessDenied) => void
  lockedResponseHandler?: (error: LockedError) => void
}

export type FetcherType<M extends RequestMethodsEnum, R = void> = (
  ...args: Parameters<AxiosInstance[M]>
) => Promise<R>
